interface ErrorProp {
    error?: Error;
}

export const ErrorView = ({error}: ErrorProp) => !error ? null : <>
        {error.name && <h2>{error.name}</h2>}
        <p className="error">{error.message ?? 'Unknown error :·('}</p>
    </>